import * as types from './mutation-types'
import {BASE_URL} from "@/services/api";

export const loadBoxes = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.get('get/boxes/collection').then((response) => {
            commit(types.ADD_BOXES, response.data)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}
export const createBoxe = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post('store/box', data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const updateBoxe = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.patch('update/' + data.id + '/box', data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const deleteBoxe = ({ commit, dispatch, state }, id) => {
    return new Promise((resolve, reject) => {
        window.axios.delete(`delete/${id}/box`).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

